import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'mwe-loading-spinner-extended-white-background',
  templateUrl: './loading-spinner-extended-white-background.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA], // Add this line to ignore errors related to the dotlottie-player
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinnerExtendedWhiteBackgroundComponent {}
